import React from "react";

import { PLATFORMS } from "../../data/content";

//Apple Podcasts / YouTube / Spotify logos. The row height is set in CSS with --platform-row
const PlatformLinks = ({ className, onDark }) => {
  return (
    <ul className={`platform-links ${className || ""}`}>
      {PLATFORMS.map((platform) => (
        <li key={platform.name}>
          <a
            href={platform.href}
            target={"_blank"}
            rel={"noopener noreferrer"}
            aria-label={`ARTdacity on ${platform.name} (opens in a new tab)`}
            style={{ "--platform-scale": platform.scale }}
          >
            <img
              src={onDark && platform.iconOnDark ? platform.iconOnDark : platform.icon}
              alt={""}
              width={platform.width}
              height={platform.height}
            />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default PlatformLinks;
